export default __webpack_public_path__ + "static/pragicts-itops-networking-13554154cef90278dd257bacccda5432.jpg";